import React from 'react'
import { withTheme } from 'styled-components'
import { Container, useScreenClass } from 'react-grid-system'

const leftPaddings = {
  xs: '1rem',
  sm: '1rem',
  md: '1rem',
  lg: '2rem',
  xl: '4rem'
}

export default withTheme(({ theme, children }) => {
  const screenClass = useScreenClass()
  return (
    <div
      style={{
        minHeight: '100%',
        margin: 0,
        padding: 0,
        paddingLeft: ['xs', 'sm', 'md'].includes(screenClass)
          ? 0
          : theme.dimensions.leftMenuWidth
      }}
    >
      <Container
        fluid
        style={{
          paddingTop: '4rem',
          paddingBottom: '2rem',
          paddingLeft: leftPaddings[screenClass]
        }}
      >
        {children}
      </Container>
    </div>
  )
})
